import { AxiosResponse, HTTPClient } from '@abaco/web-common/src/HTTP';
import { Analysis, AnalysisAssesment, AnalysisDetail, AnalysisFilter, AnalysisOut, AnalysisType, AnalysisUI } from '../models/AnalysesModel';
import { dbGIStoStandardPage, PagedResults, PagingParams } from "@abaco/web-common/src/Paging";

export default class AnalysesApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getAnalyses(pkCuaa: number, currentCampaign: number | null, filter: AnalysisFilter): Promise<AnalysisUI[]> {
        //const filterArr = [];
        // if (filter) {
        //     if (filter.description) filterArr.push(`title like ${filter.description.toUpperCase()}`);
        // }
        // filter: filterArr.length > 0 ? filterArr : undefined,
        //const res = await this.http.get(`/lucano-laboratory-analysis-api/api/v1/plots/subjects/${pkCuaa}/dictionary_workers`, {

        //change format of date to yyyy-mm-dd
        let from: string | null = null;
        if(filter && filter.dateFrom){
            const offset = filter.dateFrom.getTimezoneOffset()
            const date = new Date(filter.dateFrom.getTime() - (offset*60*1000))
            from = date.toISOString().split('T')[0]
        }
        const res = await this.http.get(`/lucano-laboratory-analysis-api/api/v1/farm/${pkCuaa}/anasisys`, {
            params: {
                campaign: currentCampaign ? currentCampaign : undefined,
                detectionType: filter && filter.type ? filter.type : undefined,
                title: filter && filter.description ? filter.description : undefined,
                from: from ? from : undefined,
                to: from ? from : undefined
            }
        });

        // FOR TESTING
        // const row1: Analysis = {
        //     id: 1,
        //     subjectId: 1,
        //     campaign: 1,
        //     detectionType: "LICHENS",
        //     dsDetectionType: "licheni",
        //     samples: 1,
        //     material: "GRASSO",
        //     farmOwner: "PIZZO PASQUALE",
        //     address: "Contrada Felicetta VIGGIANO (PZ)",
        //     species: "BOVINA",
        //     samplingDate: "2022-06-29",
        //     temperature: 4.0,
        //     title: "AAA",
        //     fileId: 1,
        //     fileMime: "AAA",
        //     fileName: "Certificazione_qualità.xlsx",
        //     dtInsert: "2022-11-16T14:54:49",
        // }
        // const row2: Analysis = {
        //     id: 2,
        //     subjectId: 1,
        //     campaign: 1,
        //     detectionType: "LICHENS",
        //     dsDetectionType: "licheni",
        //     samples: 1,
        //     material: "GRASSO",
        //     farmOwner: "PIZZO PASQUALE",
        //     address: "Contrada Felicetta VIGGIANO (PZ)",
        //     species: "BOVINA",
        //     samplingDate: "2022-06-29",
        //     temperature: 4.0,
        //     title: "AAA",
        //     fileId: 1,
        //     fileMime: "AAA",
        //     fileName: "Attestato_sanitario.xlsx",
        //     dtInsert: "2022-11-16T14:54:49",
        // }
        // const row3: Analysis = {
        //     id: 3,
        //     subjectId: 1,
        //     campaign: 1,
        //     detectionType: "MILK",
        //     dsDetectionType: "latte",
        //     samples: 1,
        //     material: "GRASSO",
        //     farmOwner: "PIZZO PASQUALE",
        //     address: "Contrada Felicetta VIGGIANO (PZ)",
        //     species: "BOVINA",
        //     samplingDate: "2022-06-29",
        //     temperature: 4.0,
        //     title: "AAA",
        //     fileId: 1,
        //     fileMime: "AAA",
        //     fileName: "Documentazione_yogurt.xlsx",
        //     dtInsert: "2022-11-16T14:54:49",
        // }
        // const row4: Analysis = {
        //     id: 4,
        //     subjectId: 1,
        //     campaign: 1,
        //     detectionType: "MEAT",
        //     dsDetectionType: "carne",
        //     samples: 1,
        //     material: "GRASSO",
        //     farmOwner: "PIZZO PASQUALE",
        //     address: "Contrada Felicetta VIGGIANO (PZ)",
        //     species: "BOVINA",
        //     samplingDate: "2022-06-29",
        //     temperature: 4.0,
        //     title: "AAA",
        //     fileId: 1,
        //     fileMime: "AAA",
        //     fileName: "Analisi_bovino.xlsx",
        //     dtInsert: "2022-11-16T14:54:49",
        // }
        // res.data = { [row1, row2, row3, row4] };

        res.data = res.data.map((e: Analysis) => {
            return { ...e, disabled: false };
        });
        return res.data;
    }

    public async getAnalysisTypes(): Promise<AnalysisType[]> {
        //const res = await this.http.get(`/lucano-laboratory-analysis-api/api/v1/plots/subjects/406926/dictionary_workers`, {
            const res = await this.http.get(`/lucano-laboratory-analysis-api/api/v1/anasisys/detectionTypes`);
        // FOR TESTING
        // const row1: AnalysisType = {
        //     code: 'LICHENS',
        //     dsCode: 'licheni',
        // }
        // const row2: AnalysisType = {
        //     code: 'MILK',
        //     dsCode: 'latte',
        // }
        // const row3: AnalysisType = {
        //     code: 'MEAT',
        //     dsCode: 'carne',
        // }
        // res.data = {
        //     count: 3,
        //     offset: 0,
        //     totalcount: 3,
        //     records: [row1, row2, row3],
        // };
        return res.data;
    }

    public async getAnalysisDetail(pkCuaa: number, analysisId: number): Promise<AnalysisDetail> {
        //const res = await this.http.get(`/lucano-laboratory-analysis-api/api/v1/plots/subjects/${pkCuaa}/dictionary_workers/`);
        const res = await this.http.get(`/lucano-laboratory-analysis-api/api/v1/farm/${pkCuaa}/anasisys/${analysisId}`);
        return res.data;
        // FOR TESTING
        // const rowAs1: AnalysisAssesment = {
        //     result: 0.65,
        //     identify: "IT076990234842",
        //     ascertainment: "PCB diossina-simili (su prodotto grasso) TeCB-77",
        //     unitMeasure: "pg/g grasso",
        //     technicalTest: "GC/HRMS",
        //     uncertainty: "AAA",
        // }
        // const rowAs2: AnalysisAssesment = {
        //     result: 0.23,
        //     identify: "IT076990234842",
        //     ascertainment: "PCB diossina-simili (su prodotto grasso) TeCB-81",
        //     unitMeasure: "pg/g grasso",
        //     technicalTest: "GC/HRMS",
        //     uncertainty: "AAA",
        // }
        // const row1: AnalysisDetail = {
        //     id: 1,
        //     subjectId: 1,
        //     campaign: 1,
        //     detectionType: "LICHENS",
        //     dsDetectionType: "licheni",
        //     samples: 1,
        //     material: "GRASSO",
        //     farmOwner: "PIZZO PASQUALE",
        //     address: "Contrada Felicetta VIGGIANO (PZ)",
        //     species: "BOVINA",
        //     samplingDate: "2022-06-29",
        //     temperature: 4.0,
        //     title: "AAA",
        //     fileId: 1,
        //     fileMime: "AAA",
        //     fileName: "Certificazione_qualità.xlsx",
        //     dtInsert: "2022-11-16T14:54:49",
        //     dataList: [rowAs1, rowAs2],
        // }
        //return row1;
    }

    public async downloadAnalysis(pkCuaa: number, analysisId: number, fileId: number): Promise<AxiosResponse> {
        const url = `/lucano-laboratory-analysis-api/api/v1/farm/${pkCuaa}/anasisys/${analysisId}/attach/${fileId}/download/b64`;
        return (await this.http.get(url))
    }

    public async deleteAnalysis(pkCuaa: number, analysisId: number): Promise<Analysis> {
        const res = await this.http.delete(`/lucano-laboratory-analysis-api/api/v1/farm/${pkCuaa}/anasisys/${analysisId}`);
        return res.data;
    }

    public async createAnalysis(pkCuaa: number, campaign: number, analysisOut: AnalysisOut, file: File | null | undefined): Promise<Analysis> {
        const formData = new FormData();
        if(file && file !== null && file !== undefined && analysisOut.file){
            formData.append("file", analysisOut.file, file.name);
        }
        // if(analysisOut.type){
        //     formData.append("type", analysisOut.type);
        // }
        const res = await this.http.post(`/lucano-laboratory-analysis-api/api/v1/farm/${pkCuaa}/anasisys/campaign/${campaign}/document/${analysisOut.type!}`, formData);
        return res.data;
    }

}
